import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItem, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/imgs/logo-white.png";
import "../assets/css/navbar.css";


const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = (open) => {
    setIsDrawerOpen(open);
  };

  return (
    <AppBar
      position="fixed"
      style={{
        backgroundColor: "#023079",
        fontFamily: "Epilogue, sans-serif",
        paddingTop: "15px",
        paddingBottom: "10px",
      }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Box display="flex" alignItems="center">
          <img
            src={logo}
            alt="SYM International Logo"
            style={{ height: 40, marginRight: "10px" }}
          />
        </Box>

        {/* Full Navbar */}
        <Box
          className="navbar-links"
          alignItems="center"
          style={{
            color: "#fff",
            fontSize: "13px",
            textTransform: "capitalize",
            display: "flex",
            marginRight: "10px",
          }}
        >
          <Link to="/" style={{ textDecoration: "none", color: "whitesmoke" }}>
            <Button color="inherit" style={{ margin: "0px 30px" }}>
              Home
            </Button>
          </Link>
          <Link to="/aboutus" style={{ textDecoration: "none", color: "whitesmoke" }}>
            <Button color="inherit" style={{ margin: "0px 30px" }}>
              About Us
            </Button>
          </Link>
          <Link to="/services" style={{ textDecoration: "none", color: "whitesmoke" }}>
            <Button color="inherit" style={{ margin: "0px 30px" }}>
              Services
            </Button>
          </Link>
          <Link to="/blogs" style={{ textDecoration: "none", color: "whitesmoke" }}>
            <Button color="inherit" style={{ margin: "0px 30px" }}>
              Blogs
            </Button>
          </Link>
          <Link to="/contactus" style={{ textDecoration: "none", color: "whitesmoke" }}>
            <Button
              variant="outlined"
              style={{
                color: "#fff",
                border: "0.2px solid #fff",
                fontSize: "13px",
                marginLeft: "15px",
                textTransform: "uppercase",
                padding: "8px 18px",
              }}
            >
              Contact Us
            </Button>
          </Link>
        </Box>

        {/* Hamburger Menu */}
        <IconButton
          edge="end"
          color="inherit"
          className="hamburger-menu"
          onClick={() => toggleDrawer(true)}
          style={{ display: "none" }}
        >
          <MenuIcon />
        </IconButton>

        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={() => toggleDrawer(false)}
        >
          <Box
            style={{ width: 250, backgroundColor: "#023079", height: "100%" }}
            role="presentation"
            onClick={() => toggleDrawer(false)}
          >
            <List>
              <ListItem>
                <img
                  src={logo}
                  alt="SYM International Logo"
                  style={{
                    height: 40,
                    margin: "10px auto",
                    display: "block",
                  }}
                />
              </ListItem>
              <ListItem button>
                <Link to="/" style={{ textDecoration: "none", color: "whitesmoke", width: "100%" }}>
                  <ListItemText primary="Home" />
                </Link>
              </ListItem>
              <ListItem button>
                <Link to="/aboutus" style={{ textDecoration: "none", color: "whitesmoke", width: "100%" }}>
                  <ListItemText primary="About Us" />
                </Link>
              </ListItem>
              <ListItem button>
                <Link to="/services" style={{ textDecoration: "none", color: "whitesmoke", width: "100%" }}>
                  <ListItemText primary="Services" />
                </Link>
              </ListItem>
              <ListItem button>
                <Link to="/blogs" style={{ textDecoration: "none", color: "whitesmoke", width: "100%" }}>
                  <ListItemText primary="Blogs" />
                </Link>
              </ListItem>
              <ListItem button>
                <Link to="/contactus" style={{ textDecoration: "none", color: "whitesmoke", width: "100%" }}>
                  <ListItemText primary="Contact Us" />
                </Link>
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;






// import React from "react";
// import { AppBar, Toolbar, Button, Box } from "@mui/material";
// import { Link } from "react-router-dom";
// import logo from "../assets/imgs/logo-white.png";

// const Navbar = () => {
//   return (
//     <AppBar
//       position="fixed"
//       style={{
//         backgroundColor: "#023079",
//         fontFamily: "Epilogue, sans-serif",
//         paddingTop: "15px",
//         paddingBottom: "10px",
//       }}
//     >
//       <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
//         {/* Logo */}
//         <Box display="flex" alignItems="center">
//           <img
//             src={logo}
//             alt="SYM International Logo"
//             style={{ height: 40, marginRight: "10px" }}
//           />
//         </Box>

//         {/* Nav Links */}
//         <Box
//           className="grid-container"
//           alignItems="center"
//           style={{
//             color: "#fff",
//             fontSize: "13px",
//             textTransform: "capitalize",
//             marginRight: "10px",
//           }}
//         >
//           <Link
//             to="/"
//             style={{ textDecoration: "none", color: "whitesmoke" }}
//           >
//             <Button color="inherit" style={{ margin: "0px 30px" }}>
//               Home
//             </Button>
//           </Link>
//           <Link
//             to="/aboutus"
//             style={{ textDecoration: "none", color: "whitesmoke" }}
//           >
//             <Button
//               color="inherit"
//               style={{ margin: "0px 30px" }}
//             >
//               About Us
//             </Button>
//           </Link>

//           <Link
//             to="/services"
//             style={{ textDecoration: "none", color: "whitesmoke" }}
//           >
//             <Button color="inherit" style={{ margin: "0px 30px" }}>
//               Services
//             </Button>
//           </Link>

//           <Link
//             to="/blogs"
//             style={{ textDecoration: "none", color: "whitesmoke" }}
//           >
//             <Button color="inherit" style={{ margin: "0px 30px" }}>
//               Blogs
//             </Button>
//           </Link>
//           <Link
//             to="/contactus"
//             style={{ textDecoration: "none", color: "whitesmoke" }}
//           >
//             <Button
//               variant="outlined"
//               style={{
//                 color: "#fff",
//                 border: "0.2px solid #fff",
//                 fontSize: "13px",
//                 marginLeft: "15px",
//                 textTransform: "uppercase",
//                 padding: "8px 18px",
//               }}
//             >
//               Contact Us
//             </Button>
//           </Link>
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default Navbar;